import React from 'react';

interface FooterProps {
  onOpenPrivacyModal: () => void;
  onOpenCookieModal: () => void;
  onOpenLegalNoticeModal: () => void;
  onOpenAboutUsModal: () => void;
}

export const Footer: React.FC<FooterProps> = ({
  onOpenPrivacyModal,
  onOpenCookieModal,
  onOpenLegalNoticeModal,
  onOpenAboutUsModal,
}) => {
  return (
    <footer className="bg-gray-800 text-gray-300 py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 items-start">
          {/* Columna 1: Logos */}
          <div className="space-y-2">
            <div className="text-2xl font-bold text-white">
              Peritajes<span className="text-yellow-400">.EU</span>
            </div>
            <div>
              <a 
                href="https://multas.eu" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-xl font-semibold text-white inline-block transition-all duration-300 hover:text-yellow-400 hover:scale-105"
              >
                Multas<span className="text-yellow-400">.EU</span>
              </a>
            </div>
            <div>
              <a 
                href="https://juzgados.eu" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-xl font-semibold text-white inline-block transition-all duration-300 hover:text-yellow-400 hover:scale-105"
              >
                Juzgados<span className="text-yellow-400">.EU</span>
              </a>
            </div>
          </div>
          
          {/* Columna 2: Contacto */}
          <div>
            <h5 className="text-lg font-semibold text-white mb-2">Contacto</h5>
            <p>Email: <a href="mailto:información@peritajes.eu" className="hover:text-yellow-400 transition-colors">información@peritajes.eu</a></p>
            <p>Teléfono: <a href="tel:+346555345" className="hover:text-yellow-400 transition-colors">+346 555 345</a></p>
          </div>
          
          {/* Columna 3: Enlaces */}
          <div>
            <h5 className="text-lg font-semibold text-white mb-2">Enlaces</h5>
            <ul className="space-y-1">
              <li>
                <button onClick={onOpenPrivacyModal} className="hover:text-yellow-400 transition-colors text-left">
                  Política de Privacidad
                </button>
              </li>
              <li>
                <button onClick={onOpenCookieModal} className="hover:text-yellow-400 transition-colors text-left">
                  Política de Cookies
                </button>
              </li>
              <li>
                <button onClick={onOpenLegalNoticeModal} className="hover:text-yellow-400 transition-colors text-left">
                  Aviso Legal
                </button>
              </li>
              <li>
                <button onClick={onOpenAboutUsModal} className="hover:text-yellow-400 transition-colors text-left">
                  Quiénes Somos
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-base font-medium mb-2">Desde 1.999 Ayudandote</p>
          <p className="text-sm">&copy; 2024 Grupo Multas (Andorra) - Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};